import Icon from '@material-ui/icons/Theaters';

import List from './List';

export default {
  name: 'walls/series',
  icon: Icon,
  list: List,
};
